import { Box3 } from "three";
import * as THREE from 'three';
import {
    GLTF,
    GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader';

export const createRoomFloor = (roomBoundingBox: Box3, floorTextureUrl: string, callback: Function) => {
    const outerWidth = roomBoundingBox.max.x - roomBoundingBox.min.x;
    const outerDepth = roomBoundingBox.max.z - roomBoundingBox.min.z;
    const geometry = new THREE.PlaneGeometry(outerWidth, outerDepth);
    const textureLoader = new THREE.TextureLoader();
    textureLoader.load(floorTextureUrl, texture => {
        const material = new THREE.MeshBasicMaterial({
            map: texture
        });
        const floor = new THREE.Mesh(geometry, material);
        floor.name = 'floor';
        floor.rotation.x = -Math.PI / 2;
        floor.position.y = roomBoundingBox.min.y;
        floor.position.x = roomBoundingBox.min.x + outerWidth / 2;
        callback(floor);
    });
}

export const updateRoomFloorTexture = (floorMesh: any, floorTextureUrl: string, callback: Function) => {
    const textureLoader = new THREE.TextureLoader();
    textureLoader.load(floorTextureUrl, texture => {
        floorMesh.material.map = texture;
        callback();
    });
}

export const getDefaultFloorTexture = () => {
    return "t6";
}

export const loadTexture = (url: string, callback: (texture: any) => void) => {
    const textureLoader = new THREE.TextureLoader();
    textureLoader.load(url, texture => {
        callback(texture);
    })
}

export const loadGLTF = (url: string, callback: (texture: GLTF) => void, errorCallback?: () => void) => {
  const productLoader = new GLTFLoader();
  productLoader.load(url, function (gltf: GLTF) {
    
    // Convert opacity to transmission before passing to callback
    convertOpacityToTransmission(gltf.scene);
    
    // Activate shadows
    activateShadows(gltf.scene);
    
    callback(gltf);
  },
  (xhr) => {
    //console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
  },
  (error) => {
    console.log(error);
    if (errorCallback)
      errorCallback();
  });
}

// Function to activate shadows on all objects in the scene
export const activateShadows = (scene: THREE.Object3D) => {
scene.traverse((object) => {
  if (object instanceof THREE.Mesh) {
    // Enable casting and receiving shadows on meshes
    object.castShadow = true;
    object.receiveShadow = true;
  }
});
}

function convertOpacityToTransmission(model: THREE.Object3D): void {
  model.traverse((c: THREE.Object3D) => {
    if ((c as THREE.Mesh).material) {
      const mesh = c as THREE.Mesh;
      const material = mesh.material as
        | THREE.MeshBasicMaterial
        | THREE.MeshStandardMaterial
        | THREE.MeshPhysicalMaterial;

      if (material.opacity < 0.85 && material.opacity > 0.1) {
        const newMaterial = new THREE.MeshPhysicalMaterial({
          color: 0xffffff,
          metalness: 0,
          roughness: 0.04,
          ior: 1.5,
          envMapIntensity: 1,
          transmission: 1,
          thickness: 1,
          specularIntensity: 1,
          specularColor: new THREE.Color(0xffffff),
          opacity: 1,
          side: THREE.DoubleSide,
          transparent: true,
        });

        // Use type assertion with Record to allow string indexing
        const materialRecord = (material as unknown) as Record<string, any>;
        const newMaterialRecord = (newMaterial as unknown) as Record<
          string,
          any
        >;

        for (const key in materialRecord) {
          if (key in materialRecord) {
            if (materialRecord[key] === null) {
              continue;
            }

            if (materialRecord[key]?.isTexture) {
              newMaterialRecord[key] = materialRecord[key];
            } else if (
              materialRecord[key]?.copy &&
              materialRecord[key].constructor ===
                newMaterialRecord[key]?.constructor
            ) {
              newMaterialRecord[key].copy(materialRecord[key]);
            } else if (typeof materialRecord[key] === "number") {
              newMaterialRecord[key] = materialRecord[key];
            }
          }
        }

        newMaterial.opacity = 1.0;
        newMaterial.transmission = 1.0;
        mesh.material = newMaterial;
      }
    }
  });
}